var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-absolute word-wrapper",class:_vm.visible ? 'pulse-animation scale transition-delay-'+_vm.delay+'' : 'invisible-transition scale',style:({ top: _vm.posTop, left: _vm.posLeft, right: _vm.posRight, bottom: _vm.posBottom })},[_c('span',{class:'font-weight-'+_vm.fontWeight+' '+_vm.fontSize+''},[_vm._v(_vm._s(_vm.word))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e36445f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Word.vue
// module id = null
// module chunks = 